import AccordionComponent, { AccordionItem } from '@/components/Accordion';
import Button from '@/components/Button';
import Container from '@/components/Container';
import {
  Render,
  Article,
  ChartContainer,
  Summary,
  TableContainer,
  NoticeBox,
} from '@/components/Css/ReportKorea';
import DonutChartComponent from '@/components/DonutChart';
import LinkSafe from '@/components/LinkSafe';
import PageComponent from '@/components/PageComponent';
import SectionHeader from '@/components/SectionHeader';
import { Tit } from '@/components/Titles';
import YoutubeSingle from '@/components/YoutubeSingle';
import React from 'react';
import { breakpoint } from '@/helpers/BreakpointHelper';
import styled from 'styled-components';

const FaqNavigationButton = styled.div`
  padding: 24px 48px 24px 24px;
  cursor: pointer;
  font-weight: bold;
  font-size: 20px;
  position: relative;
  ${breakpoint(`mobile`)} {
    font-size: 16px;
    padding: 20px 40px 20px 0;
  }
`;
const FaqAccordionBody = styled.div`
  padding: 24px;
  font-size: 16px;
  color: #2d2926;
  line-height: 1.7;
  ${breakpoint(`mobile`)} {
    font-size: 14px;
    padding: 16px 0;
  }
  ul {
    margin-top: 12px;
    li {
      position: relative;
      padding-left: 16px;
      margin-bottom: 8px;
      &::before {
        content: '';
        display: block;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: #2d2926;
        position: absolute;
        left: 0;
        top: 10px;
      }
    }
  }
  a {
    color: #1cabe2;
  }
`;

const SectionYoutube = styled.div`
  margin-bottom: 160px;
  ${breakpoint(`tablet`)} {
    margin-bottom: 160px;
  }

  ${breakpoint(`mobile`)} {
    margin-bottom: 60px;
  }
`;

const incomeData = [
  {
    type: `후원금 수입`,
    data: [
      {
        name: `정기 후원`,
        amount: 135979138488,
        rate: 78.7,
        tip: `매월 정해진 금액을 후원하는 것`,
      },
      {
        name: `일시 후원`,
        amount: 7905040994,
        rate: 4.6,
        tip: `개인이나 단체가 비정기적으로 후원하는 것`,
      },
      {
        name: `기업 후원`,
        amount: 7570802444,
        rate: 4.4,
      },
      {
        name: `비영리기관 후원`,
        amount: 953198038,
        rate: 0.5,
      },
    ],
  },
  {
    type: `후원금 외 수입`,
    data: [
      {
        name: `본부 지원금`,
        amount: 16918050180,
        rate: 9.8,
      },
      {
        name: `이자수익 및 기타`,
        amount: 1816425550,
        rate: 1.0,
        tip: `예금이자수익 등`,
      },
      {
        name: `수익사업`,
        amount: 257267205,
        rate: 0.1,
      },
      {
        name: `고유목적사업준비금환입액`,
        amount: 1489900537,
        rate: 0.9,
      },
    ],
  },
];
const incomeTotalArry = [0, 0];
incomeData.map((row, index) => {
  row.data.map((row2) => {
    incomeTotalArry[index] += row2.amount;
  });
});
const incomeTotal = incomeTotalArry[0] + incomeTotalArry[1];

const incomePerArry = [0, 0];
incomeData.map((row, index) => {
  row.data.map((row2) => {
    incomePerArry[index] += row2.rate;
  });
});

const spendingData = [
  {
    type: `고유목적사업`,
    data: [
      {
        name: `개발도상국 지원비`,
        amount: 123780399034,
        rate: 71.6,
        tip: `157개 나라의 유니세프 프로그램 지원비`,
      },
      {
        name: `아동권리 옹호 및 PR 등`,
        amount: 18822580267,
        rate: 10.9,
        tip: `후원자 관리 및 제반 홍보활동, 국내아동권리 옹호 및 교육 프로그램`,
      },
      {
        name: `인건비 및 관리 운영비`,
        amount: 9312715108,
        rate: 5.4,
        tip: `인건비 및 법인 운영관련 비용 등`,
      },
      {
        name: `본부 지원금`,
        amount: 16832414687,
        rate: 9.7,
      },
      {
        name: `기타`,
        amount: 963129020,
        rate: 0.6,
      },
    ],
  },
  {
    type: `기타사업`,
    data: [
      {
        name: `수익사업비용`,
        amount: 193551118,
        rate: 0.1,
      },
    ],
  },
  {
    type: `고유목적사업준비금전입액`,
    rowspan: true,
    data: [
      {
        name: `고유목적사업준비금전입액`,
        amount: 1459615916,
        rate: 0.8,
      },
    ],
  },
  {
    type: `법인세비용`,
    rowspan: true,
    data: [
      {
        name: `법인세비용`,
        amount: 6642285,
        rate: 0.0,
      },
    ],
  },
  {
    type: `당기운영이익`,
    rowspan: true,
    data: [
      {
        name: `당기운영이익`,
        amount: 1518776001,
        rate: 0.9,
      },
    ],
  },
];
const spendingTotalArry = [0, 0, 0, 0, 0];
spendingData.map((row, index) => {
  row.data.map((row2) => {
    spendingTotalArry[index] += row2.amount;
  });
});

const spendingTotal =
  spendingTotalArry[0] +
  spendingTotalArry[1] +
  spendingTotalArry[2] +
  spendingTotalArry[3] +
  spendingTotalArry[4];

const numberFormat = (num: number) =>
  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, `,`);

const ReportKorea2025: React.FC = (props) => (
  <Render>
    <Container>
      <ul
        className="btn-flex flex"
        css={`
          ${breakpoint(`mobile`)} {
            margin-bottom: 60px !important;
          }
        `}
      >
        <li>
          <LinkSafe
            to={`${process.env.BACKEND_URL}/unicef/api/common/attachFile/download?attUploadPath=L01JRy9jbGVhcg==&dispFileNm=2025_audit_report.pdf&svrFileNm=2025_audit_report.pdf`}
          >
            <Button outline full ico="down" className="btn-report">
              <span className="ico">감사보고서</span>
            </Button>
          </LinkSafe>
        </li>
        <li>
          <LinkSafe
            to={`${process.env.BACKEND_URL}/unicef/api/common/attachFile/download?attUploadPath=L01JRy9jbGVhcg==&dispFileNm=2025_performance_report.pdf&svrFileNm=2025_performance_report.pdf`}
          >
            <Button outline full ico="down" className="btn-report">
              <span className="ico">
                기부금 모금액 및 <br />
                활용 실적
              </span>
            </Button>
          </LinkSafe>
        </li>
        <li>
          <LinkSafe
            to="https://teht.hometax.go.kr/websquare/websquare.html?w2xPath=/ui/sf/a/c/UTESFACI01.xml"
            target="_blank"
          >
            <Button outline full ico="share" className="btn-report">
              <span className="ico">국세청 공시 시스템</span>
            </Button>
          </LinkSafe>
        </li>
      </ul>
    </Container>

    <SectionYoutube>
      <PageComponent id="youtube1">
        <YoutubeSingle videoId="Ya4hew60hdc" />
      </PageComponent>
    </SectionYoutube>

    <Container>
      <SectionHeader className="with-desc">
        <h2>
          <Tit size="s1">
            유니세프한국위원회는
            <br />
            후원금을 투명하게 운영합니다
          </Tit>
        </h2>
      </SectionHeader>

      <Article>
        <h3>
          <Tit size="s2">정기감사</Tit>
        </h3>
        <p className="dec">
          유니세프한국위원회는 내부 감사, 유니세프 본부 및 외부회계법인 감사를
          통해 후원금 사용의 투명성을 검증받습니다.
        </p>
        <NoticeBox>
          <ul className="blit-list">
            <li>
              <strong>유니세프한국위원회 내부 감사</strong> 연 1회 이사회 감사
            </li>
            <li>
              <strong>유니세프 본부 감사</strong> 연 1회 감사
            </li>
            <li>
              <strong>외부 감사</strong> 연 1회 (2025년 삼덕회계법인 감사)
            </li>
          </ul>
        </NoticeBox>
      </Article>

      <Article>
        <h3>
          <Tit size="s2">국세청 공시</Tit>
        </h3>
        <p className="dec">
          공익법인 결산서류 공시 의무에 따라 매년 국세청에 결산 서류, 연간 기부금
          모금액 및 활용실적 등을 제출하여 국세청 웹사이트에 공시합니다.
        </p>
      </Article>

      <SectionHeader className="with-desc">
        <h2>
          <Tit size="s1">유니세프한국위원회 결산</Tit>
        </h2>
        <p>
          유니세프한국위원회는 후원자님의 기부금이 어떻게 사용되는지 매년 투명하게 공개합니다. <br />
          수입, 지출, 개발도상국 지원비 결산 내역은 국세청 공익법인 공시를 통해 누구나 확인할 수 있습니다.
        </p>
      </SectionHeader>

      <Article>
        <h3 className="sky-bd">
          <Tit size="s2" color="sky">
            2025 수입
          </Tit>
        </h3>
        <ChartContainer>
          <div className="m-hide">
            <DonutChartComponent
              centerText={`<span style='font-size: 20px;'>수입</span><br><b style='font-size: 36px;letter-spacing: -1.6px;color:#3162af'>${numberFormat(
                incomeTotal,
              )}</b><b style='font-size:20px;color:#3162af'>원</b>`}
              series={[
                {
                  name: ``,
                  colorByPoint: true,
                  innerSize: `65%`,
                  type: `pie`,
                  data: [
                    {
                      name: incomeData[0].data[0].name,
                      y: incomeData[0].data[0].rate,
                    },
                    {
                      name: incomeData[0].data[1].name,
                      y: incomeData[0].data[1].rate,
                    },
                    {
                      name: incomeData[0].data[2].name,
                      y: incomeData[0].data[2].rate,
                    },
                    {
                      name: incomeData[0].data[3].name,
                      y: incomeData[0].data[3].rate,
                    },
                    {
                      name: incomeData[1].data[0].name,
                      y: incomeData[1].data[0].rate,
                    },
                    {
                      name: incomeData[1].data[1].name,
                      y: incomeData[1].data[1].rate,
                    },
                    {
                      name: incomeData[1].data[2].name,
                      y: incomeData[1].data[2].rate,
                    },
                    {
                      name: incomeData[1].data[3].name,
                      y: incomeData[1].data[3].rate,
                    },
                  ],
                },
              ]}
            />
          </div>
          <div className="pc-hide">
            <DonutChartComponent
              centerText={`<span style='font-size: 14px;'>수입</span><br><b style='font-size: 20px;letter-spacing: -1.6px;color:#3162af'>${numberFormat(
                incomeTotal,
              )}</b><b style='font-size:14px;color:#3162af'>원</b>`}
              series={[
                {
                  name: ``,
                  colorByPoint: true,
                  innerSize: `65%`,
                  type: `pie`,
                  data: [
                    {
                      name: incomeData[0].data[0].name,
                      y: incomeData[0].data[0].rate,
                    },
                    {
                      name: incomeData[0].data[1].name,
                      y: incomeData[0].data[1].rate,
                    },
                    {
                      name: incomeData[0].data[2].name,
                      y: incomeData[0].data[2].rate,
                    },
                    {
                      name: incomeData[0].data[3].name,
                      y: incomeData[0].data[3].rate,
                    },
                    {
                      name: incomeData[1].data[0].name,
                      y: incomeData[1].data[0].rate,
                    },
                    {
                      name: incomeData[1].data[1].name,
                      y: incomeData[1].data[1].rate,
                    },
                    {
                      name: incomeData[1].data[2].name,
                      y: incomeData[1].data[2].rate,
                    },
                    {
                      name: incomeData[1].data[3].name,
                      y: incomeData[1].data[3].rate,
                    },
                  ],
                },
              ]}
            />
          </div>
        </ChartContainer>
        <TableContainer>
          <table className="tbl1">
            <colgroup>
              <col className="col1" />
              <col className="col2" />
              <col className="col3" />
            </colgroup>
            <thead>
              <tr>
                <th>구분</th>
                <th>금액(원)</th>
                <th>비율</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>
                  <strong>총수입</strong>
                </th>
                <th>
                  <p className="price">{numberFormat(incomeTotal)}</p>
                </th>
                <th>
                  <p className="price">100.0%</p>
                </th>
              </tr>
            </tbody>
            {incomeData.map((row, index) => (
              <tbody key={index}>
                <tr>
                  <th>
                    <strong>{row.type}</strong>
                  </th>
                  <th>
                    <p className="price">
                      {numberFormat(incomeTotalArry[index])}
                    </p>
                  </th>
                  <th>
                    <p className="price">{incomePerArry[index].toFixed(1)}%</p>
                  </th>
                </tr>
                {row.data.map((row2) => (
                  <tr>
                    <td>
                      {row2.name} {row2.tip && `*`}
                    </td>
                    <td>
                      <p className="price">{numberFormat(row2.amount)}</p>
                    </td>
                    <td>
                      <p className="price">{row2.rate.toFixed(1)}%</p>
                    </td>
                  </tr>
                ))}
              </tbody>
            ))}
          </table>
        </TableContainer>
        <NoticeBox>
          <ul className="blit-list">
            {incomeData.map((row, index) => (
              <>
                {row.data.map((row2, index2) => (
                  <>
                    {row2.tip && (
                      <li>
                        <strong>{row2.name} : </strong>
                        {row2.tip}
                      </li>
                    )}
                  </>
                ))}
              </>
            ))}
          </ul>
        </NoticeBox>
        <p style={{ marginTop: '16px', lineHeight: 1.7 }}>
          모든 후원금은 3중 감사(내부·본부·외부)를 거쳐 검증되며, 기부금
          영수증은 매년 자동 발급되어 연말정산에 활용하실 수 있습니다.
        </p>
      </Article>

      <Article>
        <h3 className="sky-bd">
          <Tit size="s2" color="sky">
            2025 지출
          </Tit>
        </h3>
        <p>
          유니세프한국위원회는 후원자님의 기부금 지출 내역을 투명하게 공개합니다. 전체 후원금의 72%가 개발도상국 지원비로 사용되며, 나머지는 아동권리 옹호 및 PR, 안전비 및 관리 운영비 등에 사용됩니다.
        </p>
        <ChartContainer>
          <div className="m-hide">
            <DonutChartComponent
              centerText={`<span style='font-size: 20px;'>지출</span><br><b style='font-size: 36px;letter-spacing: -1.6px;color:#3162af'>${numberFormat(
                spendingTotal,
              )}</b><b style='font-size:20px;color:#3162af'>원</b>`}
              series={[
                {
                  name: ``,
                  colorByPoint: true,
                  innerSize: `65%`,
                  type: `pie`,
                  data: [
                    {
                      name: spendingData[0].data[0].name,
                      y: spendingData[0].data[0].rate,
                    },
                    {
                      name: spendingData[0].data[1].name,
                      y: spendingData[0].data[1].rate,
                    },
                    {
                      name: spendingData[0].data[2].name,
                      y: spendingData[0].data[2].rate,
                    },
                    {
                      name: spendingData[0].data[3].name,
                      y: spendingData[0].data[3].rate,
                    },
                    {
                      name: spendingData[0].data[4].name,
                      y: spendingData[0].data[4].rate,
                    },
                    {
                      name: spendingData[1].data[0].name,
                      y: spendingData[1].data[0].rate,
                    },
                    {
                      name: spendingData[2].data[0].name,
                      y: spendingData[2].data[0].rate,
                    },
                    {
                      name: spendingData[3].data[0].name,
                      y: spendingData[3].data[0].rate,
                    },
                    {
                      name: spendingData[4].data[0].name,
                      y: spendingData[4].data[0].rate,
                    },
                  ],
                },
              ]}
            />
          </div>
          <div className="pc-hide">
            <DonutChartComponent
              centerText={`<span style='font-size: 14px;'>지출</span><br><b style='font-size: 20px;letter-spacing: -1.6px;color:#3162af'>${numberFormat(
                spendingTotal,
              )}</b><b style='font-size:14px;color:#3162af'>원</b>`}
              series={[
                {
                  name: ``,
                  colorByPoint: true,
                  innerSize: `65%`,
                  type: `pie`,
                  data: [
                    {
                      name: spendingData[0].data[0].name,
                      y: spendingData[0].data[0].rate,
                    },
                    {
                      name: spendingData[0].data[1].name,
                      y: spendingData[0].data[1].rate,
                    },
                    {
                      name: spendingData[0].data[2].name,
                      y: spendingData[0].data[2].rate,
                    },
                    {
                      name: spendingData[0].data[3].name,
                      y: spendingData[0].data[3].rate,
                    },
                    {
                      name: spendingData[0].data[4].name,
                      y: spendingData[0].data[4].rate,
                    },
                    {
                      name: spendingData[1].data[0].name,
                      y: spendingData[1].data[0].rate,
                    },
                    {
                      name: spendingData[2].data[0].name,
                      y: spendingData[2].data[0].rate,
                    },
                    {
                      name: spendingData[3].data[0].name,
                      y: spendingData[3].data[0].rate,
                    },
                    {
                      name: spendingData[4].data[0].name,
                      y: spendingData[4].data[0].rate,
                    },
                  ],
                },
              ]}
            />
          </div>
        </ChartContainer>

        <TableContainer>
          <table className="tbl1">
            <colgroup>
              <col className="col1" />
              <col className="col2" />
              <col className="col3" />
            </colgroup>
            <thead>
              <tr>
                <th>구분</th>
                <th>금액(원)</th>
                <th>비율</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>
                  <strong>총지출</strong>
                </th>
                <th>
                  <p className="price">{numberFormat(spendingTotal)}</p>
                </th>
                <th>
                  <p className="price">100.0%</p>
                </th>
              </tr>
            </tbody>
            {spendingData.map((row, index) => (
              <tbody key={index}>
                <tr>
                  <th>
                    <strong>{row.type}</strong>
                  </th>
                  <th>
                    <p className="price">
                      {numberFormat(spendingTotalArry[index])}
                    </p>
                  </th>
                  <th>
                    <p className="price">
                      {((spendingTotalArry[index] / spendingTotal) * 100).toFixed(1)}%
                    </p>
                  </th>
                </tr>
                {!row.rowspan &&
                  row.data.map((row2) => (
                    <tr>
                      <td>
                        {row2.name} {row2.tip && `*`}
                      </td>
                      <td>
                        <p className="price">{numberFormat(row2.amount)}</p>
                      </td>
                      <td>
                        <p className="price">{row2.rate.toFixed(1)}%</p>
                      </td>
                    </tr>
                  ))}
              </tbody>
            ))}
          </table>
        </TableContainer>
        <NoticeBox>
          <ul className="blit-list">
            {spendingData.map((row, index) => (
              <>
                {row.data &&
                  row.data.map((row2, index2) => (
                    <>
                      {row2.tip && (
                        <li>
                          <strong>{row2.name} : </strong>
                          {row2.tip}
                        </li>
                      )}
                    </>
                  ))}
              </>
            ))}
          </ul>
        </NoticeBox>
      </Article>

      <Article>
        <h3 className="sky-bd">
          <Tit size="s2" color="sky">
            2025 개발도상국 지원비
          </Tit>
        </h3>
        <TableContainer>
          <Summary>개발도상국 어린이 지원 총계 : 123,780,399,034원</Summary>
          <table className="tbl3">
            <colgroup>
              <col className="col1" />
              <col className="col2" />
              <col className="col4" />
            </colgroup>
            <thead>
              <tr>
                <th>구분</th>
                <th>금액(원)</th>
                <th>비율</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>
                  <strong>일반사업비</strong>
                </th>
                <th>
                  <p className="price">108,458,043,712</p>
                </th>
                <th>
                  <p className="price">87.6%</p>
                </th>
              </tr>
              <tr>
                <th>
                  <strong>지정사업비</strong>
                </th>
                <th>
                  <p className="price">15,322,355,322</p>
                </th>
                <th>
                  <p className="price">12.4%</p>
                </th>
              </tr>

              <tr>
                <th colSpan="3">
                  <strong style={{ marginLeft: '15px', color: '#000' }}>
                    글로벌 캠페인
                  </strong>
                </th>
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '15px' }}>
                    에이즈 예방
                  </p>
                </td>
                <td>
                  <p className="price">5,390,568,975</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '15px' }}>
                    마음 건강
                  </p>
                </td>
                <td>
                  <p className="price">752,395,900</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '15px' }}>
                    교육
                  </p>
                </td>
                <td>
                  <p className="price">200,000,000</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '15px' }}>
                    보호
                  </p>
                </td>
                <td>
                  <p className="price">73,389,210</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '15px' }}>
                    기후 위기
                  </p>
                </td>
                <td>
                  <p className="price">34,236,127</p>
                </td>
                <td />
              </tr>

              <tr>
                <th colSpan="3">
                  <strong style={{ marginLeft: '15px', color: '#000' }}>
                    국가별 지정사업
                  </strong>
                </th>
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    동남아시아 (기후 위기)
                  </p>
                </td>
                <td>
                  <p className="price">1,511,350,006</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    방글라데시 (교육)
                  </p>
                </td>
                <td>
                  <p className="price">547,283,091</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    우간다 (보호)
                  </p>
                </td>
                <td>
                  <p className="price">519,352,072</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    라오스 (기후 위기)
                  </p>
                </td>
                <td>
                  <p className="price">441,030,000</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    필리핀 (어린이 지원)
                  </p>
                </td>
                <td>
                  <p className="price">434,580,000</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    베트남 (교육)
                  </p>
                </td>
                <td>
                  <p className="price">417,290,000</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    라오스 (교육)
                  </p>
                </td>
                <td>
                  <p className="price">296,912,997</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    몽골 (교육)
                  </p>
                </td>
                <td>
                  <p className="price">240,000,000</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    몽골 (기후 위기)
                  </p>
                </td>
                <td>
                  <p className="price">228,199,289</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    남아메리카 (교육)
                  </p>
                </td>
                <td>
                  <p className="price">140,000,000</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    지부티 (식수와 위생 등)
                  </p>
                </td>
                <td>
                  <p className="price">127,000,000</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    동티모르 (교육)
                  </p>
                </td>
                <td>
                  <p className="price">100,000,000</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    라오스 (식수와 위생)
                  </p>
                </td>
                <td>
                  <p className="price">50,000,011</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    미얀마 (식수와 위생)
                  </p>
                </td>
                <td>
                  <p className="price">30,000,000</p>
                </td>
                <td />
              </tr>

              <tr>
                <th colSpan="3">
                  <strong style={{ marginLeft: '15px', color: '#000' }}>
                    긴급구호
                  </strong>
                </th>
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    가자지구 (분쟁)
                  </p>
                </td>
                <td>
                  <p className="price">1,941,351,132</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    미얀마 (지진)
                  </p>
                </td>
                <td>
                  <p className="price">730,661,305</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    베트남 (태풍)
                  </p>
                </td>
                <td>
                  <p className="price">514,535,000</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    시리아 (지진)
                  </p>
                </td>
                <td>
                  <p className="price">352,250,000</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    수단 (기근)
                  </p>
                </td>
                <td>
                  <p className="price">229,595,107</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    아프가니스탄 (지진)
                  </p>
                </td>
                <td>
                  <p className="price">15,375,100</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    우크라이나 (분쟁)
                  </p>
                </td>
                <td>
                  <p className="price">5,000,000</p>
                </td>
                <td />
              </tr>
            </tbody>
          </table>
          <p className="tip" style={{ marginTop: '16px', fontSize: '13px' }}>* 지원금액 순</p>
        </TableContainer>
        <NoticeBox>
          <ul className="blit-list">
            <li>
              <strong>일반사업비 : </strong>전 세계 157개 개발도상국의 유니세프
              사업비(보건, 에이즈, 식수와 위생, 영양, 교육, 어린이 보호, 사회통합
              등)
            </li>
            <li>
              <strong>지정사업비 : </strong>한국위원회가 직접 지원대상국과 사업을
              지정해서 보내는 사업비
            </li>
          </ul>
        </NoticeBox>
        <p
          className="tip"
          css={`
            margin-top: 32px;
          `}
        >
          ※ 사단법인 유니세프한국위원회는 정기적인 외부회계법인의 회계감사를 통해,
          법인의 공익성과 기부금 운영 투명성을 추구하고 있습니다. <br />
          {` `}
          2025
          {` `}
          회계연도 재무제표 등 경영성과 또한 삼덕회계법인의 감사 결과 적정하게
          표시되어 있음을 인정 받았습니다.
        </p>
      </Article>
    </Container>

    <Container
      css={`
        padding: 60px 0 120px 0;
        ${breakpoint(`mobile`)} {
          padding: 40px 0 80px 0;
        }
      `}
    >
      <AccordionComponent initialKey="fund-kr-faq-1">
        <AccordionItem
          toggleKey="fund-kr-faq-1"
          renderToggle={(onClick) => (
            <FaqNavigationButton
              onClick={onClick}
              className="accordion-opener"
            >
              <h3>Q. 유니세프 기부금 사용 내역은 어떻게 확인할 수 있나요?</h3>
            </FaqNavigationButton>
          )}
        >
          <FaqAccordionBody>
            <p>
              유니세프는 모든 기부금 사용 내역을 투명하게 공개합니다. 내부감사,
              외부회계법인 감사, 유니세프 본부 감사라는 3단계 검증 시스템을 거쳐
              국세청에 공시되며, 공식 홈페이지를 통해 연차보고서와 재무제표를
              누구나 확인할 수 있습니다. 전체 후원금의 90% 이상이
              긴급구호·교육·보건·영양 등 어린이 직접 지원에 사용되며,
              정기후원자에게는 사업 성과 보고서를 정기적으로 전달합니다.
            </p>
            <ul>
              <li>
                개발도상국 지원: 전체 기부금의 대부분이 긴급구호, 교육, 보건, 영양
                등 전 세계 어린이를 위한 구호물품 및 프로그램 지원에 사용
              </li>
              <li>
                국내외 사업: 아동권리 옹호, 교육 프로그램 등 국내 아동권리 증진
                활동 및 아동 친화적 환경 조성
              </li>
            </ul>
          </FaqAccordionBody>
        </AccordionItem>
        <AccordionItem
          toggleKey="fund-kr-faq-2"
          renderToggle={(onClick) => (
            <FaqNavigationButton
              onClick={onClick}
              className="accordion-opener"
            >
              <h3>
                Q. 유니세프한국위원회는 후원금을 투명하게 운영한다는 근거로 무엇을
                제시하나요?
              </h3>
            </FaqNavigationButton>
          )}
        >
          <FaqAccordionBody>
            <p>
              유니세프한국위원회가 내부 감사, 유니세프 본부 감사, 외부회계법인
              감사를 통해 후원금 사용의 투명성을 검증받습니다. 정기감사 항목으로
              &apos;내부 감사 연 1회(이사회 감사)&apos;, &apos;유니세프 본부 감사
              연 1회&apos;, &apos;외부 감사 연 1회(2024년 삼덕회계법인
              감사)&apos;가 명시되어 있어, 기부단체 투명성 확보를 위한 다층적 점검
              구조를 확인할 수 있습니다.
            </p>
          </FaqAccordionBody>
        </AccordionItem>
        <AccordionItem
          toggleKey="fund-kr-faq-3"
          renderToggle={(onClick) => (
            <FaqNavigationButton
              onClick={onClick}
              className="accordion-opener"
            >
              <h3>
                Q. 유니세프 기부금으로 연말정산 세액공제를 받을 수 있나요?
              </h3>
            </FaqNavigationButton>
          )}
        >
          <FaqAccordionBody>
            <p>
              네, 유니세프는 법정기부금 단체로 지정되어 있어 기부금의 15~30%를
              소득세에서 공제받을 수 있습니다. 유니세프는 매년 기부금 영수증을
              자동으로 발급하며, 국세청 홈택스에서 간편하게 조회 가능합니다.
              정기후원뿐만 아니라 일시후원도 세액공제 대상에 포함되며, 연말정산 시
              기부금 영수증 세액 공제 혜택을 받으실 수 있습니다.
            </p>
            <p style={{ marginTop: '12px' }}>
              ☞{' '}
              <a href="/faq?category=6#categorySection">
                기부금 영수증/연말정산 FAQ 바로가기
              </a>
            </p>
          </FaqAccordionBody>
        </AccordionItem>
      </AccordionComponent>
    </Container>
  </Render>
);
export default ReportKorea2025;
